import { LowestPrice } from "@vp/hamilton-service-clients/dist/src/types/Pricing";
import React, { createContext, ReactChild, useEffect, useState } from "react";
import { ProductBuilderOptions } from "../types/ProductBuilderTypes";
import { MerchandisingProductView } from "../types/ContentfulTypes";
import {
  getStructuredDataPrices,
  StructuredDataPricesProps,
} from "../utils/structuredData/StructuredDataBuilder";

export interface StructuredDataContextType {
  structuredDataPrices: Record<string, LowestPrice>;
}

export const StructuredDataContext = createContext<StructuredDataContextType>({
  structuredDataPrices: {},
});

export interface StructuredDataContextProviderProps {
  locale: string;
  country: string;
  mpv: MerchandisingProductView;
  productBuilderOptions: ProductBuilderOptions;
  defaultVatIncl: boolean;
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const StructuredDataContextProvider = (props: StructuredDataContextProviderProps) => {
  const [structuredPrices, setStructuredPrices] = useState({});
  useEffect(() => {
    const initializeStructuredPrices = async () => {
      const structuredDataPricesResult = await getStructuredDataPrices({
        productBuilderOptions: props.productBuilderOptions,
        mpv: props.mpv,
        locale: props.locale,
        country: props.country,
        defaultVatIncl: props.defaultVatIncl,
      });
      setStructuredPrices(structuredDataPricesResult);
    };
    initializeStructuredPrices();
  }, []);

  const value = {
    structuredDataPrices: structuredPrices,
  };

  return (
    <StructuredDataContext.Provider value={value}>{props.children}</StructuredDataContext.Provider>
  );
};
